export const FULLFILL_USER = 'FULLFILL_USER'
export const CLEAR_STATE = 'CLEAR_STATE'
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const SET_LOGIN_ERRORS = 'SET_LOGIN_ERRORS'